import React from 'react';
// CORRECTED: 'useNavigate' has been removed from this import
import { Link } from 'react-router-dom';
import { auth } from '../firebase';

function CoaHome() {
  // CORRECTED: The unused 'navigate' constant has been removed
  const isAdmin = auth.currentUser && auth.currentUser.email === 'kishanvba@gmail.com';

  // --- STYLES ---
  const dashboardWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '20px',
  };
  const mainHeaderStyle = {
    marginBottom: '10px',
  };
  const introTextStyle = {
    marginBottom: '40px',
    color: '#6c757d',
  };
  const sectionStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #dee2e6',
    borderRadius: '8px',
    padding: '25px',
    marginBottom: '25px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    width: '100%',
    maxWidth: '800px',
  };
  const h3Style = {
    marginTop: '0px',
    marginBottom: '15px',
    borderBottom: '1px solid #e2e8f0',
    paddingBottom: '10px',
  };
  const linkStyle = {
    margin: '0 15px',
    textDecoration: 'none',
    color: '#007bff',
    fontWeight: '500',
  };
  const backButtonStyle = {
    marginTop: '30px',
    padding: '10px 20px',
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: '600',
    textDecoration: 'none',
  };

  return (
    <div style={dashboardWrapperStyle}>
      <h1 style={mainHeaderStyle}>COA Database Dashboard</h1>
      <p style={introTextStyle}>Select an option below to manage COA records.</p>
      
      <div style={sectionStyle}>
        <h3 style={h3Style}>Master Data Management</h3>
        <Link to="/products" style={linkStyle}>Manage Products</Link>
        <Link to="/customers" style={linkStyle}>Manage Customers</Link>
      </div>

      <div style={sectionStyle}>
        <h3 style={h3Style}>COA Record Management</h3>
        <Link to="/create-coa" style={linkStyle}>Create New COA Record</Link>
        <Link to="/coa-dashboard" style={linkStyle}>View All COA Records</Link>
      </div>

      <div style={sectionStyle}>
        <h3 style={h3Style}>Sample COA Management (Pre-shipment / Approvals)</h3>
        <Link to="/create-sample-coa" style={linkStyle}>Create Sample COA</Link>
        <Link to="/sample-coa-dashboard" style={linkStyle}>View All Sample COAs</Link>
      </div>

      <div style={sectionStyle}>
        <h3 style={h3Style}>Analytics & Reporting</h3>
        <Link to="/analytics" style={linkStyle}>View Analytics Dashboard</Link>
      </div>
      
      {isAdmin && (
        <div style={sectionStyle}>
          <h3 style={h3Style}>Admin Tools</h3>
          <Link to="/admin/create-user" style={linkStyle}>Create New User</Link>
        </div>
      )}
      
      <Link to="/" style={backButtonStyle}>
        Back to Main Menu
      </Link>
    </div>
  );
}

export default CoaHome;